import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  ViewChildren,
  QueryList,
} from "@angular/core";
import { ICAreaService } from "../../../services/icarea.service";
import { ICArea } from "../../../models/entities/icarea";
import { ICAreaFilter } from "../../../models/filters/icarea.filter";
import { ICAreaRelation } from "../../../models/entities/icarearelation";
import { ICAreaApi } from "../../../models/apis/icarea.api";
import { ICAreaType } from "../../../models/entities/icareatype";
import { ICUserService } from "../../../services/icuser.service";
import { Subscription } from "rxjs";
import { CustomFilter } from "../../../models/entities/customfilter";
@Component({
  selector: "app-core-tree",
  styleUrls: [
    "../../../../scss/vendors/bs-datepicker/bs-datepicker.scss",
    "../../../../scss/vendors/ng-select/ng-select.scss",
    "core-tree.component.css",
  ],
  templateUrl: "core-tree.component.html",
})
export class CoreTreeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() inputModel: number[];
  @Input() CustomFilter: CustomFilter[] = [];
  @Input() ShowLoader = true;
  @Input() MinLevel: number = null;
  @Input() LoadAll = false;
  @Input() id = -1;
  @Input() invalidIds: number[] = [];
  @Input() selectable = 0;
  @Input() MaxLevel: number;
  @Input() OnlyLevels: number[];
  @Input() sub = false;
  @Input() doTheTree = false;
  @Input() buttonText: string;
  @Input() Types: ICAreaType[] = [];
  @Input() searchTerm: string = "";
  @Input() showSearch: boolean = false;
  @Input() parentRelation: ICAreaRelation;
  @Output() inputModelChange: EventEmitter<number[]> = new EventEmitter<
    number[]
  >();
  @Output() CustomFilterChange: EventEmitter<CustomFilter[]> = new EventEmitter<
    CustomFilter[]
  >();
  @Output() SelectedArea = new EventEmitter<number>();
  Checked = false;
  @Input() area: ICAreaApi = null;
  HiddenTree = true;
  BaseLoading = false;
  Loading = 0;
  ShowCheckBox = true;
  areaSubscription: Subscription;
  @ViewChildren(CoreTreeComponent)
  childrenComponents: QueryList<CoreTreeComponent>;
  getType(): string {
    switch (this.MinLevel) {
      case 0:
        return "il Partner";
      case 1:
        return "il Cliente";
      case 2:
        return "la Location";
      case 3:
        return "l'Area";
      default:
        return "";
    }
  }
  ngOnInit() {
    if (this.LoadAll) {
      this.HiddenTree = false;
    }
    if (!this.sub) {
      if (this.id == -1) {
        this.HiddenTree = false;
        this.areaSrv.current().then((area: ICAreaApi) => {
          this.onChangeLogic(area, true);
        });
      }
      this.areaSubscription = this.areaSrv.CurrentChanged$.subscribe((area) => {
        if (area && area.Level < this.MaxLevel) {
          this.onChangeLogic(area);
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.areaSubscription != null) {
      this.areaSubscription.unsubscribe();
    }
  }

  check() {
    this.Checked = this.inputModel.findIndex((t) => t == this.area.Id) > -1;
    this.inputModelChange.emit(this.inputModel);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["inputModel"] && this.inputModel) {
      this.inputModel = this.inputModel.filter((t) => t != null);
    }
    if (changes["CustomFilter"] && this.area) {
      this.updateFilter();
    }
    if (this.inputModel && this.area) {
      this.Checked = this.inputModel.findIndex((t) => t == this.area.Id) > -1;
    }
    if (changes["id"] && this.id) {
      if (this.id == 0) {
        this.areaSrv.current().then((r) => {
          this.area = new ICAreaApi(r);
          this.onChangeLogic();
        });
      } else if (!isNaN(this.id)) {
        this.onChangeLogic();
      }
    } else if (changes["area"] && this.area) {
      this.onChangeLogic();
    }
  }

  constructor(
    protected areaSrv: ICAreaService,
    protected userSrv: ICUserService,
  ) {
    this.inputModelChange = new EventEmitter();
  }

  updateFilter() {
    window.filterResult = window.filterResult || [];
    const ctrl = this;
    let cIndex = ctrl.inputModel.indexOf(ctrl.area.Id);
    if (cIndex > -1) {
      ctrl.inputModel.splice(cIndex, 1);
    }
    cIndex = window.filterResult.indexOf(ctrl.area.Id);
    if (cIndex > -1) {
      window.filterResult.splice(cIndex, 1);
    }
    ctrl.CustomFilter.filter((t) => t.Value).some((filter) => {
      if (filter.Id == -1) {
        if (ctrl.area.TypeId == <any>filter.Value) {
          ctrl.inputModel.push(ctrl.area.Id);
          window.filterResult.push(ctrl.area.Id);
          if (window.emitFilterTimeout != null) {
            clearTimeout(window.emitFilterTimeout);
          }
          window.emitFilterTimeout = setTimeout(() => {
            ctrl.inputModelChange.emit(window.filterResult);
            window.emitFilterTimeout = null;
          }, 1500);
          return true;
        }
      } else if (ctrl.area.MetaApis) {
        const values = ctrl.area.MetaApis.filter(
          (t) => t.MetaDescriptionApi.Id == filter.Id && t.Value != null,
        );
        if (
          values.length > 0 &&
          values.filter(
            (t) =>
              filter.Value.toString()
                .toLowerCase()
                .lastIndexOf(t.Value.toString().toLowerCase()) > -1 ||
              t.Value.toLowerCase().lastIndexOf(
                filter.Value.toString().toLowerCase(),
              ) > -1,
          ).length > 0
        ) {
          ctrl.inputModel.push(ctrl.area.Id);
          window.filterResult.push(ctrl.area.Id);
          if (window.emitFilterTimeout != null) {
            clearTimeout(window.emitFilterTimeout);
          }
          window.emitFilterTimeout = setTimeout(() => {
            ctrl.inputModelChange.emit(window.filterResult);
            window.emitFilterTimeout = null;
          }, 1500);
          return true;
        }
      }
    });
  }

  setArea(event: boolean, area: ICArea) {
    if (event) {
      if (!this.inputModel) {
        this.inputModel = [];
      }
      if (this.selectable == 1) {
        this.inputModel = [area.Id];
      } else {
        this.inputModel = this.inputModel.concat(area.Id);
      }
    } else {
      this.inputModel = this.inputModel.filter((t) => t != area.Id);
    }
    this.inputModelChange.emit(this.inputModel);
  }

  callback(areaID: number) {
    this.SelectedArea.emit(areaID);
  }

  isMatch(area: ICAreaApi): boolean {
    if (!this.searchTerm) return true;
    if (!area) return false;
    const term = this.searchTerm.toLowerCase();
    const nameMatch =
      area.Name &&
      area.Name.some(
        (n) => n.Value && n.Value.toLowerCase().indexOf(term) > -1,
      );
    const codeMatch = area.Code && area.Code.toLowerCase().indexOf(term) > -1;
    const typeMatch =
      area.Type &&
      area.Type.some(
        (t) => t.Value && t.Value.toLowerCase().indexOf(term) > -1,
      );
    return !!(nameMatch || codeMatch || typeMatch);
  }

  hasMatchingChild(area: ICAreaApi): boolean {
    if (!area || !area.Childrens || area.Childrens.length === 0) return false;
    return area.Childrens.some(
      (child) =>
        this.isMatch(child.Children as ICAreaApi) ||
        this.hasMatchingChild(child.Children as ICAreaApi),
    );
  }

  selectAllFiltered() {
    const filteredIds: number[] = [];
    console.log(
      "[CoreTree] selectAllFiltered - current area:",
      this.area.Id,
      "searchTerm:",
      this.searchTerm,
    );
    this.collectAllFilteredIdsRecursive(filteredIds);
    console.log("[CoreTree] selectAllFiltered - collected ids:", filteredIds);

    const newInputModel = [...(this.inputModel || [])];
    filteredIds.forEach((id) => {
      if (newInputModel.indexOf(id) === -1) {
        newInputModel.push(id);
      }
    });
    this.inputModel = newInputModel;
    this.inputModelChange.emit(this.inputModel);
  }

  deselectAllFiltered() {
    if (!this.inputModel) return;
    const filteredIds: number[] = [];
    console.log(
      "[CoreTree] deselectAllFiltered - current area:",
      this.area.Id,
      "searchTerm:",
      this.searchTerm,
    );
    this.collectAllFilteredIdsRecursive(filteredIds);
    console.log("[CoreTree] deselectAllFiltered - collected ids:", filteredIds);

    this.inputModel = this.inputModel.filter(
      (id) => filteredIds.indexOf(id) === -1,
    );
    this.inputModelChange.emit(this.inputModel);
  }

  public collectAllFilteredIdsRecursive(ids: number[]) {
    if (this.area) {
      this.recursiveCollectFiltered(this.area, ids);
    }
  }

  private recursiveCollectFiltered(area: ICAreaApi, ids: number[]) {
    console.log("[CoreTree] recursiveCollectFiltered - area:", area.Id);
    if (this.isMatch(area)) {
      if (
        this.selectable &&
        area.Id != 0 &&
        ((this.OnlyLevels && this.OnlyLevels.indexOf(area.Level) > -1) ||
          !this.OnlyLevels ||
          this.OnlyLevels.length == 0)
      ) {
        ids.push(area.Id);
      }
    }
    if (area.Childrens) {
      console.log(
        "[CoreTree] Recursing into children of area:",
        area.Id,
        "count:",
        area.Childrens.length,
      );
      area.Childrens.forEach((child) =>
        this.recursiveCollectFiltered(child.Children as ICAreaApi, ids),
      );
    }
  }

  onChangeLogic(area?: ICAreaApi, base: boolean = false) {
    if (this.BaseLoading) {
      return;
    }
    if (base) {
      this.BaseLoading = true;
    }
    this.userSrv.current().then(async (user) => {
      const filter: ICAreaFilter = new ICAreaFilter({ UserId: user.Id });
      this.area =
        area ||
        this.area ||
        (await this.areaSrv.get(this.id, false)).ObjectResult;
      if (this.area && this.area.Id) {
        filter.AreaIds = [this.area.Id];
        this.ShowCheckBox =
          this.selectable &&
          this.area.Id != 0 &&
          ((this.OnlyLevels && this.OnlyLevels.indexOf(this.area.Level) > -1) ||
            !this.OnlyLevels ||
            this.OnlyLevels.length == 0);
        if (
          this.Types.filter((t) => t.Id == this.area.TypeId).length == 0 &&
          this.ShowCheckBox
        ) {
          this.Types.push(
            new ICAreaType({ Id: this.area.TypeId, Name: this.area.Type }),
          );
        }
        if (this.inputModel) {
          this.Checked =
            this.inputModel.findIndex((t) => t == this.area.Id) > -1;
        }
        if (this.area.Level >= this.MaxLevel) {
          filter.AreaIds = null;
          filter.Level = this.MaxLevel;
          if (
            this.area &&
            this.area.Childrens &&
            this.area.Childrens.length > 0
          ) {
            return;
          }
        }

        if (this.area.Level > 0) {
          this.area.Childrens = this.area.ChildrenIds.map(
            (t) =>
              new ICAreaRelation({
                Father: this.area,
                Children: new ICArea({ Id: t }),
              }),
          );
        }
      } else {
        filter.Level = 0;
      }
      if (this.doTheTree) {
        this.Loading++;
        this.areaSrv.list(filter, this.ShowLoader).then((r) => {
          this.Loading--;
          if (r && r.Success) {
            this.BaseLoading = false;
            this.area = new ICAreaApi({
              Id: this.area ? this.area.Id : 0,
              Name: this.area ? this.area.Name : [],
              Type: this.area ? this.area.Type : [],
              TypeId: this.area ? this.area.TypeId : 0,
              Code: this.area ? this.area.Code : null,
              Level: this.area ? this.area.Level : -1,
              Childrens: r.ListResult.filter(
                (t) => this.MaxLevel == null || t.Level <= this.MaxLevel,
              ).map((t) => new ICAreaRelation({ Children: t })),
            });
            if (this.parentRelation) {
              this.parentRelation.Children = this.area;
            }
          }
        });
      }
    });
  }
}
